<template lang="pug">

  //- CONTENT TEMPLATE
  ul.albuns(v-if="itens.length")
    li.album(v-for="item of itens", :key="item.id")
      router-link(:to="{ name: 'Album', params: { slug: item.slug } }")
        figure
          img(:src="item.imagem" alt="item.titulo")
          figcaption
            p: small.data {{ item.data }}
            p(v-html="item.titulo")

  //- LOADING TEMPLATE
  .loading-container.galeria-loading(v-else)
    span.sr-only Carregando...
    each val in [1, 2, 3, 4]
      .item
        .cover.animated
        .date.animated
        .p.animated

</template>

<style lang="scss">

</style>

<script>
  export default {
    props: {
      itens: { type: Array, required: true }
    }
  }
</script>



// WEBPACK FOOTER //
// GaleriaLista.vue?40467a9a